import script from "./MerchantCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MerchantCard.vue?vue&type=script&setup=true&lang=js"

import "./MerchantCard.vue?vue&type=style&index=0&id=4328a358&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4328a358"]])

export default __exports__